import './assets/css/App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthLayout from './layouts/auth';
import AdminLayout from './layouts/admin';
import {ChakraProvider,} from '@chakra-ui/react';
import initialTheme from './theme/theme'; //  { themeGreen }
import { useState, useContext, useCallback, useEffect, useMemo } from 'react';
import { AuthContext } from "context/index.js";
import { MarcaContext } from "context/MarcaContext";
import InactivityDetector from 'services/InactivityService';
import empresaServiceGlobal from "services/empresaService/empresa.service";
import { temaConColor } from "theme/paleta";

// Chakra imports


export default function Main() {
  // eslint-disable-next-line
  const [currentTheme, setCurrentTheme] = useState(initialTheme);
  const [marca, setMarca] = useState(null);
  const authContext = useContext(AuthContext);

  // Nombre, color y logo de la empresa (Configuraciones > Empresa). Si falla se queda
  // con la marca que trae la app.
  const recargarMarca = useCallback(async () => {
    const response = await empresaServiceGlobal.getMarca();
    if (response?.data) setMarca(response.data);
  }, []);

  useEffect(() => {
    recargarMarca();
  }, [recargarMarca]);

  useEffect(() => {
    if (marca?.color) setCurrentTheme(temaConColor(initialTheme, marca.color));
  }, [marca?.color]);

  // Ícono de la pestaña: el logo pequeño de la empresa, si lo subieron.
  useEffect(() => {
    if (!marca?.logoPequeno) return;
    document.querySelectorAll("link[rel~='icon'], link[rel='apple-touch-icon']").forEach((link) => {
      link.href = marca.logoPequeno;
      link.removeAttribute("type");
    });
  }, [marca?.logoPequeno]);

  const valorMarca = useMemo(() => ({ marca, recargar: recargarMarca }), [marca, recargarMarca]);

  const handleUserInactive = useCallback(() => {
    authContext.logout("Inactividad usuario");
  }, [authContext]);
  return (
    <ChakraProvider theme={currentTheme}>
      <MarcaContext.Provider value={valorMarca}>
        <InactivityDetector onInactive={handleUserInactive} />
        <Routes>
          <Route path="auth/*" element={<AuthLayout />} />
          <Route path="admin/*" element={<AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />} />
          <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />
        </Routes>
      </MarcaContext.Provider>
    </ChakraProvider>
  );
}
